import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { UserDetailsService } from 'src/app/service/user-details.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  user: any = {}

  constructor(
    private userDetailsService: UserDetailsService,
    private titleService: Title,
    private router: Router,) { }

  ngOnInit(): void {
    this.titleService.setTitle('Profile')
    this.user = this.userDetailsService.getUserDetails();
  }

  editUser() {

  }

  changePassword() {
    this.router.navigate(['/settings/changepassword'], { queryParams: { 'page': 'home', 'username': this.user?.loginId } })
  }
}
